document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => {
            drawer.renderContents({sections: res}) 
            ckResetCountdown();
        });
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        drawer.open();
        
    }
});

// CK | sticy buttons background
(function () {
  function init() {
    const el = document.querySelector('.tee-form-actions');

    if (!el || el.offsetHeight === 0) {
      return setTimeout(init, 800);
    }

    let sentinel = el.previousElementSibling;
    if (!sentinel || !sentinel.classList.contains('tee-sticky-sentinel')) {
      sentinel = document.createElement('div');
      sentinel.innerHTML = '&nbsp;';
      sentinel.style.cssText = 'height:0px;visibility:hidden;pointer-events:none;';
      sentinel.className = 'tee-sticky-sentinel';
      el.parentNode.insertBefore(sentinel, el);
    }

    const topOffset = parseInt(getComputedStyle(el).top || '0', 10) || 0;
    let sentinelAbsTop = 0;

    const recompute = () => {
      const rect = sentinel.getBoundingClientRect();
      sentinelAbsTop = rect.top + window.scrollY;
      update();
    };

    const update = () => {
    const triggerPoint = window.scrollY + window.innerHeight * 0.85;
    const shouldStick = triggerPoint < sentinelAbsTop;

    el.classList.toggle('is-sticky', shouldStick);
    };

    el.classList.add('is-sticky');

    let rafId = null;
    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        update();
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', recompute);

    setTimeout(recompute, 1000);
  }

  init();
})();
// end of CK | sticy buttons background

// CK | Live add-on price badges (Oct 2026)
// Why: the price of upsell options (gift bags, boxes) used to be baked into the option image.
//   Every price change meant editing images by hand, and other markets could show the wrong price.
// Rule: the option image stays plain. We read which Shopify variant each Teeinblue option adds
//   (from the Teeinblue campaign data the page already preloads) and show that variant's live
//   Shopify price for the current market as a badge. Change the price in Shopify, the badge follows.
// Style: html[data-ck-badge="1..5"] picks the badge look. Chosen look is 4 (price below the tile, pink when selected).
//   ?ckbadge=N still switches the look for testing.
// Image: the option thumbnail is taken from Shopify (variant image, else the add-on product image),
//   so the clean upsell images in Shopify are shown everywhere. ?ckimg=0 turns this off for testing.
//   Because of this the thumbnails can be removed in Teeinblue. Teeinblue then prints the option name
//   as text inside the tile; we hide that text on tiles we manage.
// "None" option: in a field with priced options, the option without an add-on (e.g. "Kein") always
//   gets our crossed-circle icon and "+0,00€" below it, like the prices of the other tiles (Leon 25.10.2026:
//   transparent pricing; before that it showed no text).
//   It is the default in Teeinblue, so the customer clearly sees that nothing extra is selected.
// Colour chooser fields (e.g. ornaments: "Satinbeutel" Kein / Rosa / Grau / Schwarz): the options carry no
//   add-on themselves, but each colour opens its own priced field (Einzeln, 2er-Set, ...) through a
//   Teeinblue dependency. Such a colour tile shows the Shopify image of the first option of the field it
//   opens (the single bag), without a price, because the price is shown in the field below. "Kein" gets the
//   crossed circle. So no thumbnails are needed in Teeinblue here either, and there is no exception.
// Switched off add-ons: a tile whose add-on variant is in window.ckAddonsOff (snippets/ck-addons-off.liquid,
//   variant metafield custom.addon_live = false) is hidden. Used for a new bag that is already in the
//   TeeInBlue campaign but not yet in stock at Printeers. The stock job switches it on.
// Theme bag block: on products the theme bag block serves (snippets/lh-bag-upsell.liquid), the TeeInBlue
//   bag fields are hidden (bagFieldTakenOver). Printeers upsells are maintained in the theme.
// Global options (Printlabs upsells, e.g. "Printlabs Geschenkbox Weinglas [DE] bis 4"): same rules. Their
//   choices sit in the campaign's global_options and the inputs are named "global-option-<id>".
// Count cap: for add-on products in CAP_BY_PIECES (wine glass gift box) the customer can pick at most one per
//   piece of the chosen set (Einzel = 1 box, 2er-Set = 2 boxes ...). Tiles above that are hidden. If the picked
//   box count is now too high (set made smaller), the field falls back to the highest count that is still allowed.
//   Pieces come from the active "Verfügbare Produkte" radio label (first number, none = 1), else from the
//   variant SKU (-set-N). The box count of a tile is the SKU suffix of its add-on variant (-1..-4) x rate.
// Info icon: a field whose add-on product is in window.lhAddonInfo (snippets/lh-addon-info.liquid), or a colour
//   chooser whose colours open such a field (tealight gift box), gets the pink info icon of the print file check
//   after its heading (own class: the print file check script listens
//   to .ck-datacheck__tooltip and would open its own popup too). A tap opens the same popup look with photo.
// AI photo texts: TeeInBlue shows "Generate image", "Generate again", "Image generated" and "Only N photos are
//   allowed." in English. They are swapped for the market's locale texts (window.lhTeeTexts, lh-addon-info.liquid).
// Photo guide: on products tagged "lh-photo-guide" (window.lhAddonInfo["photo-guide"]) every photo upload field
//   gets the same icon; it opens the photo guide in that popup. Runs on its own observer, add-on mapping or not.
(function () {
  var params = new URLSearchParams(location.search);
  var style = params.get('ckbadge');
  try {
    if (style) sessionStorage.setItem('ckbadge', style);
    else style = sessionStorage.getItem('ckbadge');
  } catch (e) {}
  if (!/^[1-5]$/.test(style || '')) style = '4';
  document.documentElement.setAttribute('data-ck-badge', style);
  var imgMode = params.get('ckimg');
  try {
    if (imgMode) sessionStorage.setItem('ckimg', imgMode);
    else imgMode = sessionStorage.getItem('ckimg');
  } catch (e) {}
  imgMode = imgMode !== '0';
  var NONE_ICON = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="21" fill="none" stroke="#141214" stroke-width="5"/><path d="M17.2 17.2l29.6 29.6" stroke="#141214" stroke-width="5" stroke-linecap="round"/></svg>');
  var shopImages = {}; // variantId -> image url (or '' while loading / not found)

  var addonsOff = (window.ckAddonsOff || []).map(String);
  var CAP_BY_PIECES = ['15410987499785']; // Printlabs - Gift box for wine glasses
  var optionAddons = null; // 'layer-id|option-id' -> [{id, rate}]
  var chooserAddons = {}; // 'layer-id|option-id' of a colour chooser -> add-ons of the first option it opens
  var openedByChooser = {}; // layer ids of priced fields a colour chooser opens (their info icon sits on the chooser)

  function campaignUrl() {
    var link = document.querySelector('link[href*="api.teeinblue.com/api/merchant/campaigns/"]');
    if (link) return link.href;
    var entry = (performance.getEntriesByType('resource') || []).find(function (e) {
      return /api\.teeinblue\.com\/api\/merchant\/campaigns\//.test(e.name);
    });
    return entry ? entry.name : null;
  }

  // Option ids are only unique inside one layer (e.g. "Einzeln" exists in the pink, grey and black
  // bag layers with the same id), so the key is "layer id|option id", like the input's name|value.
  function loadMapping() {
    return waitForCampaignUrl().then(function (url) {
      if (!url) return null;
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return null;
          var map = {};
          (function walk(node) {
            if (!node || typeof node !== 'object') return;
            if (Array.isArray(node)) { node.forEach(walk); return; }
            if (typeof node.id === 'string' && node.id.indexOf('layer-') === 0 && Array.isArray(node.options)) {
              node.options.forEach(function (o) {
                if (o && o.id != null && Array.isArray(o.addons) && o.addons.length) {
                  map[node.id + '|' + o.id] = o.addons.map(function (a) {
                    return { id: String(a.id), rate: Number(a.rate) || 1, product: String(a.product_id || '') };
                  });
                }
              });
              var first = node.options[0];
              var deps = node.dependency && Array.isArray(node.dependency.dependencies) ? node.dependency.dependencies : [];
              if (first && Array.isArray(first.addons) && first.addons.length) {
                if (deps.length) openedByChooser[node.id] = true;
                deps.forEach(function (d) {
                  [].concat(d.value || []).forEach(function (v) {
                    chooserAddons[d.element + '|' + v] = first.addons.map(function (a) {
                      return { id: String(a.id), rate: Number(a.rate) || 1, product: String(a.product_id || '') };
                    });
                  });
                });
              }
            }
            Object.keys(node).forEach(function (k) { walk(node[k]); });
          })(data.artworks || data);
          // Global options: the layer only points to the option, the choices live in data.global_options.
          // TeeInBlue names the inputs "global-option-<id>", so the key is "global-option-<id>|option id".
          (data.global_options || []).forEach(function (g) {
            var opts = g && g.data && Array.isArray(g.data.options) ? g.data.options : [];
            opts.forEach(function (o) {
              if (o && o.id != null && Array.isArray(o.addons) && o.addons.length) {
                map['global-option-' + g.id + '|' + o.id] = o.addons.map(function (a) {
                  return { id: String(a.id), rate: Number(a.rate) || 1, product: String(a.product_id || '') };
                });
              }
            });
          });
          return map;
        });
    }).catch(function () { return null; });
  }

  // The Teeinblue SDK may add its campaign preload a moment after the DOM is ready, so wait up to 10 s.
  function waitForCampaignUrl() {
    return new Promise(function (resolve) {
      var tries = 0;
      (function check() {
        var url = campaignUrl();
        if (url || tries++ > 40) return resolve(url);
        setTimeout(check, 250);
      })();
    });
  }

  // Same rule as Teeinblue: of the add-ons listed on an option, the first one that exists in this
  // product's add-on variants is the one that gets charged.
  function chargedAddon(addons, prices) {
    var list = (window.teeinblueCampaign && window.teeinblueCampaign.addonVariants) || [];
    for (var i = 0; i < list.length; i++) {
      var id = String(list[i].id);
      for (var j = 0; j < addons.length; j++) {
        if (addons[j].id === id && prices[id] != null) return addons[j];
      }
    }
    return null;
  }

  function sized(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=180';
  }

  function variantImage(id) {
    if (id in shopImages) return shopImages[id];
    shopImages[id] = '';
    var list = (window.teeinblueCampaign && window.teeinblueCampaign.addonVariants) || [];
    var v = list.find(function (x) { return String(x.id) === id; });
    if (v && v.featured_image && v.featured_image.src) {
      shopImages[id] = sized(v.featured_image.src);
      return shopImages[id];
    }
    // No variant image: fall back to the add-on product's main image.
    fetch('/variants/' + id, { credentials: 'same-origin' })
      .then(function (r) { return fetch(r.url.split('?')[0] + '.js'); })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.featured_image) { shopImages[id] = sized(p.featured_image); render(); }
      })
      .catch(function () {});
    return '';
  }

  function variantPrices() {
    var out = {};
    var list = (window.teeinblueCampaign && window.teeinblueCampaign.addonVariants) || [];
    list.forEach(function (v) { out[String(v.id)] = v.price; }); // cents, current market
    return out;
  }

  function formatMoney(cents) {
    var shop = typeof window.lhMoney === 'function' ? window.lhMoney(cents) : null; // the market's Liquid money format
    if (shop) return shop;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var lang = (document.documentElement.lang || 'de').slice(0, 2);
    try {
      var s = new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(cents / 100);
      return cur === 'EUR' ? s.replace(/\s/g, '') : s; // shop writes "2,95€"
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' ' + cur;
    }
  }

  function setImg(wrap, src) {
    var img = wrap.querySelector('img');
    if (!img || !src || img.getAttribute('src') === src) return;
    img.setAttribute('src', src);
    img.removeAttribute('srcset');
    img.removeAttribute('lazy');
    img.style.objectFit = 'contain';
  }

  function setLabel(wrap, name, text, cls) {
    var badge = wrap.querySelector(':scope > .ck-addon-price');
    if (!badge) {
      badge = document.createElement('span');
      badge.setAttribute('aria-hidden', 'true');
      wrap.appendChild(badge);
    }
    badge.className = 'ck-addon-price' + (cls ? ' ' + cls : '');
    wrap.classList.add('ck-has-addon-price');
    if (badge.dataset.text !== text || badge.dataset.name !== name) {
      badge.dataset.text = text;
      badge.dataset.name = name;
      badge.innerHTML = '<span class="ck-addon-price__name"></span><span class="ck-addon-price__value"></span>';
      badge.firstChild.textContent = name;
      badge.lastChild.textContent = text;
    }
  }

  function render() {
    if (!optionAddons) return;
    var prices = variantPrices();
    document.querySelectorAll('.tee-field').forEach(function (field) {
      var inputs = field.querySelectorAll('.tee-clipart > .tee-checkbox-input');
      var key = function (i) { return i.name + '|' + i.value; };
      var hasAddons = Array.prototype.some.call(inputs, function (i) { return optionAddons[key(i)]; });
      var isChooser = !hasAddons && Array.prototype.some.call(inputs, function (i) { return chooserAddons[key(i)]; });
      if (bagFieldTakenOver(field, inputs, key, prices, isChooser ? chooserAddons : optionAddons)) return;
      if (!hasAddons) {
        if (isChooser) {
          renderChooser(inputs, key, prices);
          addInfo(field, inputs, key, chooserAddons); // e.g. tealight gift box: the icon sits on the colour field
        }
        return;
      }
      inputs.forEach(function (input) {
        var addons = optionAddons[key(input)];
        var wrap = input.parentElement;
        var label = wrap.querySelector('label');
        var name = label ? (label.getAttribute('data-title') || '') : '';
        if (!addons) {
          // the "none" option of an upsell field
          wrap.classList.add('ck-none-tile');
          setImg(wrap, NONE_ICON);
          setLabel(wrap, name, '+' + formatMoney(0), 'ck-addon-price--none'); // "+0,00€", same transparency as the priced tiles
          return;
        }
        var addon = chargedAddon(addons, prices);
        if (hideIfOff(wrap, input, addon)) return;
        if (hideIfOverCap(wrap, addon)) return;
        var total = addon ? prices[addon.id] * addon.rate : 0;
        wrap.classList.add('ck-addon-tile');
        if (imgMode && addon) setImg(wrap, variantImage(addon.id));
        if (!addon || total <= 0) {
          var b = wrap.querySelector(':scope > .ck-addon-price');
          if (b) b.remove();
          return;
        }
        setLabel(wrap, name, '+' + formatMoney(total), '');
      });
      fallBackIfOverCap(inputs);
      addInfo(field, inputs, key);
    });
  }

  // Info icon after the field heading, for add-on products listed in window.lhAddonInfo.
  function addInfo(field, inputs, key, map) {
    var infos = window.lhAddonInfo || {};
    var pid = null;
    map = map || optionAddons;
    Array.prototype.some.call(inputs, function (i) {
      return (map[key(i)] || []).some(function (a) { if (infos[a.product]) { pid = a.product; return true; } return false; });
    });
    var heading = field.querySelector('.tee-field__heading');
    if (!pid || !heading || heading.querySelector('[data-lh-addon-info]')) return;
    if (map === optionAddons && inputs[0] && openedByChooser[inputs[0].name]) return; // one icon, on the chooser
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lh-addon-info';
    btn.setAttribute('data-lh-addon-info', pid);
    btn.setAttribute('aria-label', (infos[pid].title || '') + ': Info');
    var star = heading.querySelector('.tee-asterisk');
    heading.insertBefore(btn, star ? star.nextSibling : null);
  }

  // Info icon on photo upload fields (single or multiple uploads), for the photo guide.
  function addPhotoGuide() {
    if (!(window.lhAddonInfo || {})['photo-guide']) return;
    document.querySelectorAll('.tee-field').forEach(function (field) {
      if (!field.querySelector('input[type="file"]')) return;
      var heading = field.querySelector('.tee-field__heading');
      if (!heading || heading.querySelector('[data-lh-addon-info]')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lh-addon-info';
      btn.setAttribute('data-lh-addon-info', 'photo-guide');
      btn.setAttribute('aria-label', (window.lhAddonInfo['photo-guide'].title || '') + ': Info');
      var star = heading.querySelector('.tee-asterisk');
      heading.insertBefore(btn, star ? star.nextSibling : null);
    });
  }

  // Swap TeeInBlue's English AI photo texts inside the form for the market's texts.
  function translateTee() {
    var t = window.lhTeeTexts;
    if (!t) return;
    document.querySelectorAll('.tee-field .tee-photo, .tee-field .tee-photo-action').forEach(function (box) {
      var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var raw = node.nodeValue;
        var txt = raw.trim();
        if (!txt) continue;
        var out = null;
        if (t[txt] && txt !== 'max_photos') out = t[txt];
        var m = /^Only (\d+) photos? (?:are|is) allowed\.?$/.exec(txt);
        if (m && t.max_photos) out = t.max_photos.replace('{{ count }}', m[1]);
        if (out && out !== txt) node.nodeValue = raw.replace(txt, out);
      }
      var btn = box.querySelector('.tee-btn--upload[aria-label]');
      if (btn && t[btn.getAttribute('aria-label')]) btn.setAttribute('aria-label', t[btn.getAttribute('aria-label')]);
    });
  }

  function infoModal() {
    var m = document.querySelector('[data-lh-addon-modal]');
    if (m) return m;
    m = document.createElement('div');
    m.className = 'ck-info-modal';
    m.setAttribute('data-lh-addon-modal', '');
    m.hidden = true;
    m.innerHTML = '<div class="ck-info-modal__panel" role="dialog" aria-modal="true">' +
      '<button type="button" class="ck-info-modal__close" data-lh-addon-close aria-label="Close">✕</button>' +
      '<img class="ck-info-modal__img" alt="">' +
      '<h3 class="ck-info-modal__title"></h3><p class="ck-info-modal__text"></p>' +
      '<button type="button" class="button button--primary button--full-width" data-lh-addon-close></button></div>';
    document.body.appendChild(m);
    return m;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-lh-addon-info]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      var info = (window.lhAddonInfo || {})[t.getAttribute('data-lh-addon-info')];
      if (!info) return;
      var m = infoModal();
      m.querySelector('.ck-info-modal__img').src = info.img || '';
      m.querySelector('.ck-info-modal__title').textContent = info.title || '';
      m.querySelector('.ck-info-modal__text').textContent = info.text || '';
      m.querySelector('.button[data-lh-addon-close]').textContent = info.ok || 'OK';
      m.hidden = false;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'lh_addon_info_opened', lh_addon_product: t.getAttribute('data-lh-addon-info') });
      } catch (err) {}
      return;
    }
    var c = e.target && e.target.closest && (e.target.closest('[data-lh-addon-close]') || (e.target.matches('[data-lh-addon-modal]') ? e.target : null));
    if (c) { var mm = document.querySelector('[data-lh-addon-modal]'); if (mm) mm.hidden = true; }
  }, true);

  document.addEventListener('keydown', function (e) {
    var mm = document.querySelector('[data-lh-addon-modal]');
    if (e.key === 'Escape' && mm) mm.hidden = true;
  });

  // Colour chooser: image from Shopify, no price (the price sits in the field the colour opens).
  function renderChooser(inputs, key, prices) {
    inputs.forEach(function (input) {
      var wrap = input.parentElement;
      var addons = chooserAddons[key(input)];
      if (!addons) {
        wrap.classList.add('ck-none-tile');
        setImg(wrap, NONE_ICON);
        return;
      }
      var addon = chargedAddon(addons, prices);
      if (hideIfOff(wrap, input, addon)) return;
      wrap.classList.add('ck-addon-tile');
      if (imgMode && addon) setImg(wrap, variantImage(addon.id));
    });
  }

  // Theme bag block (snippets/lh-bag-upsell.liquid): while it serves the selected variant, TeeInBlue
  // fields whose priced options only add bag variants are hidden and set back to their first option
  // ("Kein"), so the customer never sees two bag fields. Shown again when the block does not serve the
  // variant (e.g. a Printlabs set of a mixed product).
  function bagFieldTakenOver(field, inputs, key, prices, map) {
    var takes = typeof window.lhBagTakesOver === 'function' && window.lhBagTakesOver();
    var bags = takes && typeof window.lhBagAllVariants === 'function' ? window.lhBagAllVariants() : [];
    var ids = [];
    inputs.forEach(function (i) {
      var a = map[key(i)];
      var c = a ? chargedAddon(a, prices) : null;
      if (c) ids.push(c.id);
    });
    var isBagField = ids.length > 0 && ids.every(function (id) { return bags.indexOf(id) !== -1; });
    if (takes && isBagField) {
      if (field.style.display !== 'none') field.style.display = 'none';
      field.dataset.lhBagHidden = '1';
      var checked = Array.prototype.find.call(inputs, function (i) { return i.checked; });
      // label click (pick), else TeeInBlue keeps the old bag and charges it although the screen shows "Kein" (QA 26.10.2026)
      if (checked && map[key(checked)] && inputs[0] && inputs[0] !== checked) pick(inputs[0]);
      return true;
    }
    if (field.dataset.lhBagHidden) { field.style.display = ''; delete field.dataset.lhBagHidden; }
    return false;
  }

  // Hides the tile of a switched off add-on. If it was somehow selected, the field falls back to its
  // first option (the "none" option, which is the default in Teeinblue).
  function hideIfOff(wrap, input, addon) {
    if (!addon || addonsOff.indexOf(addon.id) === -1) return false;
    if (wrap.style.display !== 'none') wrap.style.display = 'none';
    if (input.checked) {
      var first = wrap.parentElement && wrap.parentElement.querySelector('.tee-clipart > .tee-checkbox-input');
      if (first && first !== input) pick(first);
    }
    return true;
  }

  // Pieces of the chosen set: number in the active "Verfügbare Produkte" label ("2er-Set", "Lot de 3"),
  // "Einzel" / "Unité" = 1. Without that field: the variant SKU (-set-N), else 1.
  function pieces() {
    var active = document.querySelector('#tee-field--teeinblue-available-prod .tee-radio.active label');
    if (active) {
      var m = (active.textContent || '').match(/\d+/);
      return m ? Number(m[0]) : 1;
    }
    var input = document.querySelector('form[data-type="add-to-cart-form"] .product-variant-id') ||
                document.querySelector('.product-variant-id');
    var id = String((input && input.value) || new URLSearchParams(location.search).get('variant') || '');
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var v = meta && (meta.variants || []).find(function (x) { return String(x.id) === id; });
    var s = v && String(v.sku || '').match(/-set-(\d+)$/);
    return s ? Number(s[1]) : 1;
  }

  // Boxes a tile adds: SKU suffix of the add-on variant (PLS-VXITM10025-3 = 3) x rate. 0 = not capped.
  function cappedCount(addon) {
    if (!addon || CAP_BY_PIECES.indexOf(addon.product) === -1) return 0;
    var list = (window.teeinblueCampaign && window.teeinblueCampaign.addonVariants) || [];
    var v = list.find(function (x) { return String(x.id) === addon.id; });
    var m = v && String(v.sku || '').match(/-(\d+)$/);
    return (m ? Number(m[1]) : 1) * (addon.rate || 1);
  }

  function hideIfOverCap(wrap, addon) {
    var n = cappedCount(addon);
    if (n) wrap.dataset.lhCount = String(n);
    var over = n > pieces();
    if (over) {
      if (wrap.style.display !== 'none') wrap.style.display = 'none';
      wrap.dataset.lhCapped = String(n);
    } else if (wrap.dataset.lhCapped) {
      wrap.style.display = '';
      delete wrap.dataset.lhCapped;
    }
    return over;
  }

  // The picked tile got hidden by the cap: pick the highest box count that is still shown.
  function fallBackIfOverCap(inputs) {
    var checked = Array.prototype.find.call(inputs, function (i) { return i.checked; });
    if (!checked || !checked.parentElement.dataset.lhCapped) return;
    var best = null;
    var bestN = -1;
    inputs.forEach(function (i) {
      var w = i.parentElement;
      if (w.dataset.lhCapped || w.style.display === 'none') return;
      var n = Number(w.dataset.lhCount || 0); // "Keine" has none = 0
      if (n > bestN) { bestN = n; best = i; }
    });
    if (best) pick(best);
  }

  // Click the label, not the input: TeeInBlue only takes a choice from the label click. A click on the input changes
  // the radio on screen but leaves TeeInBlue's own value, which is what goes into the cart (QA 26.10.2026: 4 wine
  // glasses with 4 boxes, then 1 glass showed "1 box" but added the 4 boxes for 19,95 € instead of 4,95 €).
  function pick(input) {
    var l = input.parentElement && input.parentElement.querySelector('label');
    if (l) l.click(); else input.click();
  }

  // For assets/lh-gift-box.js (the wine glass gift box block): pieces of the chosen set, and what a TeeInBlue
  // add-on input adds ({ id, product, n = boxes, cents }, null for the "none" option or before the campaign loaded).
  window.lhSetPieces = pieces;
  window.lhTeeAddon = function (input) {
    var addons = optionAddons && input && optionAddons[input.name + '|' + input.value];
    if (!addons) return null;
    var prices = variantPrices();
    var a = chargedAddon(addons, prices);
    if (!a) return null;
    var list = (window.teeinblueCampaign && window.teeinblueCampaign.addonVariants) || [];
    var v = list.find(function (x) { return String(x.id) === a.id; });
    var m = v && String(v.sku || '').match(/-(\d+)$/);
    return { id: a.id, product: a.product, n: (m ? Number(m[1]) : 1) * a.rate, cents: prices[a.id] * a.rate };
  };

  // A set change only toggles a class on the radio, which the observer below does not watch.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest || !e.target.closest('#tee-field--teeinblue-available-prod')) return;
    [60, 400, 1200].forEach(function (t) { setTimeout(render, t); });
  }, true);

  function start() {
    if ((window.lhAddonInfo || {})['photo-guide'] || window.lhTeeTexts) {
      var guidePending = false;
      var photoFields = function () { addPhotoGuide(); translateTee(); };
      photoFields();
      new MutationObserver(function () {
        if (guidePending) return;
        guidePending = true;
        setTimeout(function () { guidePending = false; photoFields(); }, 30);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    loadMapping().then(function (map) {
      if (!map || !Object.keys(map).length) return;
      optionAddons = map;
      render();
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        // setTimeout, not requestAnimationFrame: rAF never fires in a tab that loads in the background.
        setTimeout(function () { pending = false; render(); }, 30);
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    });
  }

  // Start as soon as the DOM is ready (the campaign data is preloaded), so the swap happens early.
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
// end of CK | Live add-on price badges
